export const BANK_NAMES = [
  "KB국민은행",
  "하나은행",
  "신한은행",
  "우리은행",
  "IBK기업은행",
  "NH농협",
  "카카오뱅크",
  "토스뱅크",
  "케이뱅크",
  "iM뱅크",
  "SC제일은행",
  "한국씨티은행",
  "MG새마을금고",
  "부산은행",
  "경남은행",
  "광주은행",
  "전북은행",
  "신협",
  "KDB산업은행",
  "제주은행",
  "수협은행",
] as const;

export const BANK_CODES = {
  "KB국민은행": "006",
  "하나은행": "081",
  "신한은행": "088",
  "우리은행": "020",
  "IBK기업은행": "003",
  "NH농협": "011",
  "카카오뱅크": "090",
  "토스뱅크": "092",
  "케이뱅크": "089",
  "iM뱅크": "031",
  "SC제일은행": "023",
  "한국씨티은행": "027",
  "MG새마을금고": "045",
  "부산은행": "032",
  "경남은행": "039",
  "광주은행": "034",
  "전북은행": "037",
  "신협": "048",
  "KDB산업은행": "002",
  "제주은행": "035",
  "수협은행": "007",
}

export type BankName = typeof BANK_NAMES[number];